<template>
    <HeaderMain />
    <div class="home-screen">
        <router-view v-if="isInitialized"/>
    </div>
    <FooterMain/>
</template>

<script src="./main-view-component.ts">
</script>